import { ReactNode } from "react";

export const TableScrollContainer = ({
  children,
  emptyContent,
}: {
  children: ReactNode;
  stickyHeader?: boolean;
  /** Shown under the header when the table has no rows: inside the scroll
   *  area, so the whole table still scrolls, but stuck to the visible width
   *  so it is centred on screen rather than in the full width of a
   *  many-column table, where the centre can be far off screen. */
  emptyContent?: ReactNode;
}) => {
  return (
    // Inline-size container so the empty block below can be sized to the
    // visible width (100cqw) while living inside the scrolling area.
    <div className="flex flex-col flex-1 overflow-hidden TableScrollContainer [container-type:inline-size]">
      {/* Scrolls both axes with the browser's native scrollbars, so the
          vertical scrollbar always sits at the visible right edge. When the
          header is sticky it pins itself to the top of this container.
          No horizontal padding here: it would inset the rows, cutting their
          border-bottom short of the table edges. Cells pad their own content.
          With no rows the whole area (header and the empty block) still
          scrolls horizontally, with the scrollbar hidden (scrollbar-none),
          and the empty block sticks to the visible width so it stays centred
          on screen rather than in the full width of a many-column table. */}
      <div
        className={
          emptyContent
            ? "flex flex-col flex-1 w-full overflow-auto scrollbar-none"
            : "flex flex-1 w-full overflow-auto"
        }
      >
        {children}
        {emptyContent && (
          <div className="sticky left-0 w-[100cqw] p-5 text-center text-muted">
            {emptyContent}
          </div>
        )}
      </div>
    </div>
  );
};
